import React from 'react';
import { connect } from 'react-redux';
import { Steps, Col, Row, Layout } from 'antd';
import TramittaLogo from '../../../images/tramitta-logo.png';
import LegalChileLogo from '../../../images/legalchile.svg';
import YapoLogo from '../../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../../config/constants/urls';
import PropTypes from 'prop-types';

const { Step } = Steps;
const { Header } = Layout;

const CreateContractHeader = ({ steps, sourceUrl, activeStep }) => {

  return (
    <Header className="header-container header-contract-form">
      <Row className="header-logos">
        <img src={LegalChileLogo} alt="" className="legal-logo" />
        {sourceUrl === EXTERNAL_URL.YAPO &&
          <img src={YapoLogo} alt="" className="yapo-logo" />
        }
        <img src={TramittaLogo} alt="" className="tramitta-logo" />
      </Row>
      <Row>
        <Col sm={24}>
          <Steps current={activeStep}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </Col>
      </Row>
    </Header>
  );
};

CreateContractHeader.propTypes = {
  sourceUrl: PropTypes.string,
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
};

const data = (state) => ({
  sourceUrl: state.contract.sourceUrl
});

export default connect(data)(CreateContractHeader);